import {MemberStateConstant} from '../constants';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationState: LtFramework.IAlertNotificationState = {
	alertNotifications: new Array<LtFramework.IAlertNotification>(),
};

export const ClubState: LtFramework.IClubState = {
	club: {
		initialized: false,
	} as LtFramework.IClub,
};

export const ProfileState: LtFramework.IProfileState = {
	profile: {
		memberState: MemberStateConstant.unknown,
		initialized: false,
	} as LtFramework.IProfile,
};

export const UrlState: LtFramework.IUrlState = {
	url: {
		initialized: false,
	} as LtFramework.IUrl,
};
